import axios from "axios";

export const getICXPricingInUSD = () => {
  return axios.get(
    "https://api.coingecko.com/api/v3/simple/price?ids=icon&vs_currencies=usd"
  );
};
